import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const applyRulesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Apply Rules',
		isVisible: (): boolean => {
			return false;
			// const uPanelItem = ui.pointer.context.ref as UsePanelItem;
			// const rules = getKitchenReferenceRules({ refMap: uPanelItem._referenceMap });
			// return rules.item.length > 0;
		}
		// onClick: ({ appDispatch, appState }): void => appDispatch({
		// 	type: BlueprintActionTypes.RunPanelItemRules,
		// 	payload: {
		// 		id: appState.ui.pointer.context.ref?.id ?? ''
		// 	}
		// })
	}
};
